import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DimensionsView } from "src/components/views/erp/common/accounting/dimensions/DimensionsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/common/accounting/dimensions")({
	staticData: { title: i18n.t("dimensions"), legacyViewKey: "dimensionsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <DimensionsView />;
}
